module.exports = __webpack_public_path__ + "static/img/ic_file_pdf.0894b9f9.png";